import React, { FC, FormEventHandler, useEffect, useState } from 'react';
import Typography from '@/components/atoms/project-builder/typography';
import Button from '@/components/atoms/project-builder/button';
import IconPlus from '@/components/icons/plus';
import IconMinus from '@/components/icons/minus';
import Checkbox from '@/components/atoms/checkbox';

interface IProps {
  project: any;
  selectedProjects: any;
  handleIncrement: (shoppingListId: string, roomLabel: any, existingItem?:any) => void;
  handleRoomSelection: (project: any, roomLabel: any, existingItem?:any) => void;
  handleDecrement: (shoppingListId: string, roomLabel: string, existingItem?:any) => void;
  handleAddNote: (src: any) => void;
  productToAdd:any
}

const Rooms: React.FC<IProps> = ({
  project,
  selectedProjects,
  handleIncrement,
  handleDecrement,
  handleRoomSelection,
  handleAddNote,
  productToAdd,
}) => {
  // const [showMore, setShowMore] = useState<boolean>(false);
 
  const getChecked = (project: any, roomLabel: any, existingItem?: any) => {
    return (
      // Case 1: A new room is added
      (// Case 3: No selected item but existing item exists
      selectedProjects.some(
        (selectedProject: any) =>
          selectedProject.shoppingListId === project.shoppingListId &&
          selectedProject.selectedRooms.some(
            (r: any) => r.roomLabel === roomLabel && !r.lineItemId
          )
      ) ||
      // Case 2: Existing item is already selected with roomNotes or quantity
      (!!existingItem?.id &&
        selectedProjects.some(
          (selectedProject: any) =>
            selectedProject.shoppingListId === project.shoppingListId &&
            selectedProject.selectedRooms.some(
              (r: any) =>
                r.roomLabel === roomLabel &&
                r.lineItemId === existingItem.id &&
                (!!r.quantity || !!r.roomNotes)
            )
        )) || (!!existingItem?.id && !selectedProjects.some(
        (selectedProject: any) =>
          selectedProject.shoppingListId === project.shoppingListId &&
          selectedProject.selectedRooms.some(
            (r: any) => r.roomLabel === roomLabel && r.lineItemId === existingItem.id
          )
      )))
    );
  };
  
  
  
  const getRoomQuantity = (roomLabel: string, shoppingListId?: string, existingItem?: any): number => {
    const project = shoppingListId
      ? selectedProjects.find((proj: any) => proj.shoppingListId === shoppingListId)
      : selectedProjects.find((proj: any) => proj.selectedRooms.some((r: any) => r.roomLabel === roomLabel));
  
    if (!project && !existingItem?.id) return 0;
  
    const room = project?.selectedRooms.find((r: any) => r.roomLabel === roomLabel);
    if (room && !room.quantity) return 0;
  
    return room?.quantity ?? existingItem?.quantity ?? 0;
  };
  
  const getRoomNotes = (shoppingListId: string, roomLabel: string, existingItem?: any): string => {
    const project = selectedProjects.find((project: any) => project.shoppingListId === shoppingListId);
  
    if (!project) return existingItem?.roomNotes ?? '';
  
    const room = project.selectedRooms.find((room: any) => room.roomLabel === roomLabel);
  
    // Return roomNotes from the room or fallback to existingItem
    return room?.roomNotes ?? existingItem?.roomNotes ?? '';
  };

  return (
    <div>
      <div className="flex flex-col gap-[12px] px-[12px]">
        {project?.roomLabels?.map((roomLabel: any,idx:any) => {
          return (
            <div key={idx}>
              <Room
                roomLabel={roomLabel}
                project={project}
                getChecked={getChecked}
                handleRoomSelection={handleRoomSelection}
                handleDecrement={handleDecrement}
                handleIncrement={handleIncrement}
                getRoomQuantity={getRoomQuantity}
                handleAddNote={handleAddNote}
                getRoomNotes={getRoomNotes}
                productToAdd={productToAdd}
              />
            </div>
          );
        })}
      </div>
      {/* {rooms.length > 6 && (
        <div className='px-8 md:!pb-22'>
          <button
            onClick={() => setShowMore(!showMore)}
            className="text-[14px] text-[#666] hover:text-[#090909] hover:!cursor-pointer underline"
          >
            {showMore ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )} */}
    </div>
  );
};

export default Rooms;

const Room: FC<any> = ({
  roomLabel,
  project,
  getChecked,
  handleRoomSelection,
  handleDecrement,
  handleIncrement,
  getRoomQuantity,
  getRoomNotes,
  handleAddNote,
  productToAdd,
}) => {
  const [addNote, setAddNote] = useState<boolean>(false);
  const [note, setNote] = useState<string>('');
  const noteActionButtonClass =
    'border-1 z-10 rounded-none border px-[13px] py-[9px] shadow-sm h-[56px] flex-1 md:flex-none md:w-[140px]';

  const existingItem = project.lineItems.find((item: any) => {
    const baseMatch = item.name === productToAdd.name && item.roomName === roomLabel;
    const hasSku = item?.variant?.sku && productToAdd?.sku;
  
    return hasSku ? (baseMatch && item.variant.sku === productToAdd.sku): baseMatch;
  });
  

  useEffect(() => {
    setNote(getRoomNotes(project.shoppingListId, roomLabel, existingItem));
  }, [addNote]);
const quantity = getRoomQuantity(roomLabel, project.shoppingListId, existingItem);
  const isMaxQty = quantity >= 9999;
  return (
    <div key={roomLabel}>
      <div className="flex items-center justify-between">
        <label 
         className="flex items-center justify-start gap-[12px]">
          <Checkbox
            id={roomLabel}
            checked={!!getChecked(project, roomLabel, existingItem)}
            className="hover:cursor-pointer"
            containerClassName="!gap-[0px]"
            onClick={(e:any) => {
              e.stopPropagation();
              handleRoomSelection({
                project,
                roomLabel,
                ...(existingItem?{existingItem} : {}),
              });
            }}
          />
          <span
            className="w-fit text-[16px] font-normal text-[#090909] md:text-[14px]  2xl:text-[16px]"
          >
            <Typography as='span' className="w-fit  text-[16px] hover:cursor-pointer">
              {roomLabel}
            </Typography>
          </span>
          <div className="flex items-center gap-[12px]"></div>
        </label>
        {!!getChecked(project, roomLabel, existingItem) && (
          <div className="flex items-center gap-[10px] select-none">
            <IconMinus className="cursor-pointer" onClick={() => handleDecrement(project.shoppingListId, roomLabel, existingItem)} />
            <span className="text-[14px] text-[#090909]">{quantity}</span>
            <IconPlus
              className={`cursor-pointer ${isMaxQty ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
              onClick={() => {
                if (!isMaxQty) {
                  handleIncrement(project.shoppingListId, roomLabel, existingItem);
                }
              }}
            />
          </div>
        )}
      </div>
      {!!getChecked(project, roomLabel, existingItem) && !addNote && (
        <button type="button" className="padding-l-32 pt-[12px] select-none	" onClick={() => setAddNote(true)}>
          <Typography className="cursor-pointer text-[#090909] underline  ">Add a note</Typography>
        </button>
      )}
      {addNote && !!getChecked(project, roomLabel, existingItem) && (
        <div className="padding-l-32 pt-[12px]">
          <textarea
            name="note"
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
            }}
            placeholder="Note"
            maxLength={300}
            autoComplete=""
            rows={5}
            className="w-full rounded border border-[#DDDDDD]  focus:border-gray-600 focus:ring-0 focus:outline-none  px-[13px] py-[6px] text-left !text-[14px] text-black placeholder:text-[#666666]"
          />
          <div className="flex items-center padding-b-24 gap-[32px] pt-[12px]">
            <Button
              disabled={!existingItem?.roomNotes && !note}
              onClick={() => {
                handleAddNote({shoppingListId:project.shoppingListId, roomLabel, note, existingItem});
                setAddNote(false);
              }}
              className={
                `${noteActionButtonClass} !border-[#2B2C39] !bg-[#1A1A1A] hover:!bg-[#394A54] disabled:!border-neutral-400 disabled:!text-neutral-100 disabled:!bg-neutral-400`
              }
            >
              <Typography as="span" className={`text-[14px] font-medium whitespace-nowrap`}>
                Add note
              </Typography>
            </Button>
            <Button
              onClick={() => {
                setAddNote(false);
                setNote('');
              }}
              className={
                `${noteActionButtonClass} !border-[#2B2C39] bg-white hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]`
              }
            >
              <Typography as="span" className={`text-[14px] font-medium text-[#090909] whitespace-nowrap`}>
                Cancel
              </Typography>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
